import { render, staticRenderFns } from "./NonEudoxusExchangeComponent.vue?vue&type=template&id=cf380840&scoped=true&"
import script from "./NonEudoxusExchangeComponent.vue?vue&type=script&lang=js&"
export * from "./NonEudoxusExchangeComponent.vue?vue&type=script&lang=js&"
import style0 from "./NonEudoxusExchangeComponent.vue?vue&type=style&index=0&id=cf380840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf380840",
  null
  
)

component.options.__file = "NonEudoxusExchangeComponent.vue"
export default component.exports